<template>
    <div>
        <div><span class="title">{{ title }}</span>
            <span class="required" v-if="required">*</span>
        </div>
        <div class="email-input-container">
            <div class="email-tag" v-for="(email, index) in tos" :key="index">
                {{ email }}
                <button class="remove-button" @click="removeEmail(index)">
                    <i class="fa-solid fa-circle-xmark"></i>
                </button>
            </div>
            <input v-model="newItem" @keyup.enter="addItem" :placeholder="placeholder" class="email-input" />
        </div>
    </div>
</template>

<script>
export default {
    name: "InputTag",
    props: {
        title: String,
        placeholder: String,
        required: Boolean,
        initialValue: Array,
        value: Array,
        change: Function
    },
    data() {
        return {
            tos: [],
            newItem: ""
        };
    },
    mounted() {
        this.tos = this.initialValue;
    },
    methods: {
        addItem() {
            if (this.newItem) {
                this.tos.push(this.newItem);
                this.newItem = "";
                this.change();
            }
        },
        removeEmail(index) {
            this.tos.splice(index, 1);
            this.change();
        }
    },
    watch: {
        tos: {
            handler(tos) {
                this.$emit("input", tos);
            },
            deep: true,
        },
        initialValue: {
            handler(initialValue) {
                this.tos = initialValue;
            },
            deep: true,
        },
    },

};
</script>

<style>
.email-input-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border: 1px solid #E5E4E8;
    border-radius: 6px;
    padding-left: 5px;
}

.email-tag {
    display: flex;
    align-items: center;
    background-color: #f0f0f0;
    padding: 4px 8px;
    border-radius: 16px;
    margin-top: 6px;
    margin-right: 8px;
    margin-bottom: 8px;
}

.remove-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    cursor: pointer;
    margin-left: 4px;
    outline: none;
}

.remove-button {
    color: #ff0000;
}

.remove-button:hover {
    color: #ff0000;
}

.email-input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 14px;
    padding: 4px;
    font-weight: 400 !important;
    margin: 2px 5px 2px 5px;
    background-color: transparent;
}

.email-input::placeholder {
    font-weight: 300 !important;
    opacity: 0.5;
    color: #969595;
}
</style>